import { Dialog } from 'primereact/dialog';
import React, { useState } from 'react';
import BaseButton from '../form/BaseButton.jsx';
import IconCloseFull from '../images/IconCloseFull.jsx';
import { InputSwitch } from 'primereact/inputswitch';
import BaseCalendar from './BaseCalendar.jsx';
import dayjs from 'dayjs';
import BaseInputCalendar from '../form/BaseInputCalendar.jsx';
import { convertDateAndTimeToUTCDateTime } from '../../utils/helper.js';

const DateTimeProposal = ({ visible, setVisible, isLoading, handleRespond, proposedValues }) => {
    const [selectedDates, setSelectedDates] = useState([
        proposedValues.proposed_start_date ? new Date(proposedValues.proposed_start_date) : new Date(),
        proposedValues.proposed_end_date ? new Date(proposedValues.proposed_end_date) : new Date()
    ]);
    const [allDay, setAllDay] = useState(false);
    const [proposed, setProposed] = useState({
        proposed_start_date: proposedValues.proposed_start_date
            ? new Date(proposedValues.proposed_start_date)
            : new Date(),
        proposed_end_date: proposedValues.proposed_end_date ? new Date(proposedValues.proposed_end_date) : new Date()
    });

    const hasTime = (isoString) => {
        const dateObj = new Date(isoString);
        return dateObj.getUTCHours() !== 0 || dateObj.getUTCMinutes() !== 0 || dateObj.getUTCSeconds() !== 0;
    };

    const [endTime, setEndTime] = useState(
        hasTime(proposedValues.proposed_end_date) ? new Date(dayjs(proposedValues.proposed_end_date)) : ''
    );
    const [startTime, setStartTime] = useState(
        hasTime(proposedValues.proposed_start_date) ? new Date(dayjs(proposedValues.proposed_start_date)) : ''
    );

    const hideDialog = () => {
        setVisible(false);
    };

    const changeDates = (value) => {
        setSelectedDates(value);
        setStartTime('');
        setEndTime('');
        setProposed({
            proposed_start_date: value[0],
            proposed_end_date: value.length > 1 ? value[1] : value[0]
        });
    };

    const checkAndModifyEndTime = (newStartTime) => {
        if (
            dayjs(proposed.proposed_start_date).format('YYYY-MM-DD') ===
                dayjs(proposed.proposed_end_date).format('YYYY-MM-DD') &&
            (!endTime || dayjs(newStartTime) > dayjs(endTime))
        ) {
            setEndTime(newStartTime);
        }
    };

    const handleOnClick = () => {
        const updatedProposed = {
            proposed_start_date: convertDateAndTimeToUTCDateTime(proposed.proposed_start_date, startTime),
            proposed_end_date: convertDateAndTimeToUTCDateTime(
                proposed.proposed_end_date,
                endTime !== '' ? endTime : startTime
            )
        };

        handleRespond('proposed-change', updatedProposed);
    };

    if (!visible) return null;

    return (
        <Dialog
            className='rounded-4xl !w-[500px]'
            visible={visible}
            style={{ marginLeft: '15px', marginRight: '15px' }}
            breakpoints={{ '420px': '320px' }}
            onHide={hideDialog}
            content={() => (
                <div className='flex flex-col justify-center items-center px-6 py-8 pt-12 bg-white rounded-4xl'>
                    <button onClick={hideDialog} className='absolute top-6 right-6'>
                        <IconCloseFull className='fill-theme1-text5' />
                    </button>
                    <div className='text-theme1-title2 w-full mb-[30px] leading-tight'>
                        <div className={'font-bold text-center text-[22px] mb-[10px]'}>Propose a date/time change</div>
                        <BaseCalendar
                            value={selectedDates}
                            setDate={changeDates}
                            selectionMode='range'
                            minDate={new Date()}
                        />
                        <div className={'px-[8px]'}>
                            <div className='flex items-center space-x-2'>
                                <InputSwitch
                                    inputId={'switch'}
                                    name='all_day'
                                    checked={allDay}
                                    onChange={() => setAllDay(!allDay)}
                                />
                                <label htmlFor={'switch'} className={'text-theme1-primary2 text-lg cursor-pointer'}>
                                    All day event
                                </label>
                            </div>
                            <div className='flex items-center justify-between mt-2'>
                                <div className='text-theme1-primary2'>Starts:</div>
                                <div className='col-span-2 font-bold'>
                                    {proposed.proposed_start_date
                                        ? dayjs(proposed.proposed_start_date).format('MMM DD, YYYY')
                                        : ''}
                                </div>
                                {!allDay && (
                                    <div className='w-20'>
                                        <BaseInputCalendar
                                            name='startTime'
                                            value={startTime}
                                            setValue={setStartTime}
                                            timeOnly
                                            placeholder='Time'
                                            extraOnChange={(value) => checkAndModifyEndTime(value)}
                                        />
                                    </div>
                                )}
                            </div>
                            <div className='flex items-center justify-between mt-2'>
                                <div className='text-theme1-primary2'>Ends:</div>
                                <div className='col-span-2 font-bold'>
                                    {proposed.proposed_end_date
                                        ? dayjs(proposed.proposed_end_date).format('MMM DD, YYYY')
                                        : ''}
                                </div>
                                {!allDay && (
                                    <div className='w-20'>
                                        <BaseInputCalendar
                                            name='endTime'
                                            value={endTime}
                                            setValue={setEndTime}
                                            timeOnly
                                            placeholder='Time'
                                            minDate={
                                                dayjs(proposed.proposed_start_date).format('YYYY-MM-DD') ===
                                                    dayjs(proposed.proposed_end_date).format('YYYY-MM-DD') && startTime
                                                    ? new Date(startTime)
                                                    : null
                                            }
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className='flex justify-between gap-4 w-full'>
                        <BaseButton
                            className='btn-red-outline w-[47%] flex-shrink-0'
                            textValue='Cancel'
                            onClick={hideDialog}
                        />

                        <BaseButton
                            className='bg-theme1-primary text-white w-[47%] flex-shrink-0'
                            textValue={isLoading ? 'Inviting...' : 'Confirm'}
                            onClick={handleOnClick}
                            disabled={isLoading}
                        />
                    </div>
                </div>
            )}
        ></Dialog>
    );
};

DateTimeProposal.displayName = 'DateTimeProposal';

export default DateTimeProposal;
